import React, { useEffect, useState } from 'react'
import './styles.css'
import CardHotelResult from './CardHotelResult'
import Paginado from '../Paginado/Paginado' 


const AllCardsResults = ({data, currentPage, mostrarNext, prevHandler, nextHandler, dataS}) => {
 



      

  return (
    <div className='contain-all-results-hotels'>
        {

            Array.isArray(data) === false ?
                <h2 style={{textAlign:'center'}}>No se encontraron resultados</h2>
            :
            data.map((item,key)=>{
                return(
                    <CardHotelResult key={key} data={item}/>
                )
            })
        }
        <Paginado currentPage={currentPage} data={dataS} mostrarNext={mostrarNext} nextHandler={nextHandler} prevHandler={prevHandler}/>
    </div>
  )
}
export default AllCardsResults